import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchEmployeeTypeList = createAsyncThunk(
  "fetchEmployeeTypeList",
  async ({ page, filters, limit }) => {
    const keyword = filters && filters.keyword !== undefined ? `${filters.keyword}` : "";

    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };

    const response = await axiosHttp.get(
      `et/list?page=${page}&limit=${limit}&keyword=${keyword}`,
      config
    );

    return response.data.data;
  }
);

const employeeTypeListSlice = createSlice({
  name: "employeeTypeList",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchEmployeeTypeList.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchEmployeeTypeList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.page;
      state.total = action.payload.total;
    });
    builder.addCase(fetchEmployeeTypeList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default employeeTypeListSlice.reducer;